import { serverFetch } from "@core/server";

export function fetchSprServisList(vid) {
  return serverFetch(`sprs/servis?vid=${encodeURIComponent(vid)}`);
}

export function fetchSprServis(vid, id) {
  return serverFetch(`sprs/servis/${vid}/${id}`);
}

export function createSprServis(bodyData) {
  return serverFetch("sprs/servis", {
    method: "POST",
    bodyData
  });
}

export function saveSprServis(bodyData) {
  return serverFetch("sprs/servis", {
    method: "PUT",
    bodyData
  });
}

export function deleteSprServis(vid, id) {
  return serverFetch(`sprs/servis/${vid}/${id}`, {
    method: "DELETE"
  });
}
